<template>
  <layout-bottom-sheet ref="bottomSheet">
    <template v-slot:header>
        <span class="title">
          {{ getContent(popupsData, defaultLocalePopupsData, 'codeVerify.enterCode') }}
        </span>
    </template>

    <modal-content-code-verify
      ref="codeVerifyForm"
      @close="close"
      :contactDetail="contactDetail"
      :reason="reason"
      :type="type"
      :passFormData="passFormData"
      @update:isLoading="isLoading = $event"
      @success="emit('success', $event)"
    />

    <template v-slot:footer>
      <button-base
        type="primary"
        size="md"
        @click="handleSubmit"
        :isDisabled="isLoading"
        :isProcessing="isLoading"
      >
        {{ getContent(layoutData, defaultLocaleLayoutData, 'buttons.confirm') }}
      </button-base>
    </template>
  </layout-bottom-sheet>
</template>

<script setup lang="ts">
  import type { IBottomSheetComponent, IChangeFormData } from '@skeleton/core/types';

  withDefaults(
    defineProps<{
      contactDetail: string;
      reason?: 'registration' | 'phoneVerification' | 'changingPass' | 'emailVerification';
      type: 'email' | 'phone';
      passFormData?: IChangeFormData;
    }>(),
    {
      contactDetail: '',
    },
  );

  const globalStore = useGlobalStore();
  const { getContent } = useProjectMethods();

  const {
    layoutData,
    defaultLocaleLayoutData,
    popupsData,
    defaultLocalePopupsData,
  } = storeToRefs(globalStore);

  const bottomSheet = ref<Maybe<IBottomSheetComponent>>();
  const codeVerifyForm = ref(null);
  const isLoading = ref(false);

  const emit = defineEmits(['close', 'success']);

  const handleSubmit = () => {
    codeVerifyForm.value!.verifyCode();
  };

  const close = (): void => {
    bottomSheet.value!.close();
  };

  const open = async () => {
    await bottomSheet.value!.open();
    codeVerifyForm.value?.sendVerifyCode();
  };

  defineExpose({
    open,
    close,
  });
</script>


